// import { initHomeSlider } from '@js/common/swiperInit.js';
// import { initFancybox } from '@js/common/fancybox.js';
import deviceMenu from '@js/common/deviceMenu.js';
const mainHeader = document.querySelector('.main-header');
let lastScroll = 0;

deviceMenu();
// initHomeSlider();
// initFancybox();

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    /* Process buttons */
    // document.querySelectorAll('.btn-link, .btn-play').forEach(function (element) {
    //     if (element.classList.contains('btn-link')) {
    //         appendSVGBtn(element, '#icon-btn-arrow', '24', '15');
    //     } else if (element.classList.contains('btn-play')) {
    //         appendSVGBtn(element, '#icon-play-btn', '10', '13');
    //     }
    // });
    /* Process buttons End */
    setHeaderHeight();
    headeraddClass();


    /* Use jQuery code Start */
    (function($) {
    // Write code here
    })(jQuery);
    /* Use jQuery code End */
});

window.addEventListener('resize', () => {
    setHeaderHeight();
});


/* Script all functions
------------------------------------------------------------------------------*/
// Function to create and append SVG to an element
// function appendSVGBtn(element, iconId, width, height) {
//     var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
//     svg.setAttribute('aria-hidden', 'true');
//     svg.setAttribute('width', width);
//     svg.setAttribute('height', height);

//     var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
//     use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', iconId);

//     svg.appendChild(use);
//     element.appendChild(svg);
// }

function setHeaderHeight() {
    const header = document.querySelector('header');
    if (header) {
        const headerHeight = header.offsetHeight;
        document.querySelector('.home-hero , header').style.setProperty('--headerHeight', headerHeight + 'px');
    }
}

/* Header add class and slide up top bar */
function headeraddClass() {
    if (!mainHeader) {
        return;
    }

    const handleScroll = () => {
        const currentScroll = window.scrollY;
        if (currentScroll > 80) {
            mainHeader.classList.add('scroll');
        } else {
            mainHeader.classList.remove('scroll');
        }

        if (currentScroll > lastScroll && currentScroll > 80) {
            mainHeader.classList.add('header-pinned');
        } else if (currentScroll < lastScroll) {
            mainHeader.classList.remove('header-pinned');
        }

        lastScroll = currentScroll;
    };

    // Bind scroll listener
    window.addEventListener('scroll', handleScroll);
};




